/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Access_Denied_ActionInputs */

const en_auth_error_access_denied_action = /** @type {(inputs: Auth_Error_Access_Denied_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request access on GitLab`)
};

const fr_auth_error_access_denied_action = /** @type {(inputs: Auth_Error_Access_Denied_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander l'accès sur GitLab`)
};

const ms_sg2_auth_error_access_denied_action = /** @type {(inputs: Auth_Error_Access_Denied_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta akses di GitLab`)
};

/**
* | output |
* | --- |
* | "Request access on GitLab" |
*
* @param {Auth_Error_Access_Denied_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const auth_error_access_denied_action = /** @type {((inputs?: Auth_Error_Access_Denied_ActionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Access_Denied_ActionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_error_access_denied_action(inputs)
	if (locale === "fr") return fr_auth_error_access_denied_action(inputs)
	return ms_sg2_auth_error_access_denied_action(inputs)
});